import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { WA_WINDOW } from '@ng-web-apis/common';
import { FacebookPixelComponent } from '@rma/generic/ui/facebook-pixel';
import { ViewportHeightService } from '@rma/generic/util/device-size';

@Component({
  selector: 'rma-find-my-agent-root',
  template: `<rma-facebook-pixel /> <router-outlet />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, RouterOutlet, FacebookPixelComponent],
})
export class AppComponent {
  public constructor() {
    const window = inject<Window>(WA_WINDOW);

    inject(ViewportHeightService).initialise();

    if (!window.location.href.includes('www') && !window.location.host.includes('dev') && !window.location.host.includes('localhost')) {
      const index = 'https://'.length;
      const newUrl = `www.${window.location.href.slice(index)}`;
      window.location.href = newUrl;
    }
  }
}
